<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add Route Set</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-exchange-form">
            <div  [ngClass]="{'mb-3': form.controls.broker.errors?.length > 0}" [ngClass]="{ 'hidden': hideBroker }"  class="col-12">
                <app-select (ngModelChange)="handleBrokerChange($event)" [control]="form.controls.broker" [formControlName]="form.controls.broker.name"></app-select>
            </div>
            <div [ngClass]="{'mb-3': form.controls.name.errors?.length > 0}" class="col-12">
                <app-panel-input [control]="form.controls.name" [formControlName]="form.controls.name.name"></app-panel-input>
            </div>
            <ng-container [formArrayName]="form.routeSetFormControlsRouteArraySelector">
                <div
                    *ngFor="let control of form.controls.routes; let i = index"
                    class="col-12"
                    [ngClass]="{'mb-3': control.errors.length > 0}"
                >
                    <app-checkbox
                        [formControlName]="i"
                        [control]="control"
                    >
                        <ng-container text>{{control.placeholder}}</ng-container>
                    </app-checkbox>
                </div>
                <div *ngIf='form.routesErrors.length > 0' class="form-text text-danger mt-3">
                    <span *ngFor="let error of form.routesErrors">{{error}}</span>
                </div>
            </ng-container>
        </form>
    </ng-container>
</app-dialog>
